import React, { FC, useRef } from 'react'

const UseRefComponent: FC = function () {
  const inputRef = useRef<HTMLInputElement>(null)

  const onButtonClick = () => {
    if (inputRef.current === null) {
      return
    }

    inputRef.current.focus()
  }

  return (
    <>
      <button type="button" onClick={onButtonClick}>
        Focus the input
      </button>
      <input ref={inputRef} />
    </>
  )
}

export default UseRefComponent
